function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function setAffiliateCookie() {
    const affiliateValue = getParameterByName('aff');
    if (affiliateValue && affiliateValue.trim() !== "") {
        fetch(`/api/Affiliate/SetAffiliateCookie?aff=${affiliateValue}`);
    }
}

document.addEventListener('DOMContentLoaded', setAffiliateCookie);
